import api from "./axios";
import { apiPaths } from "./paths";
import type { Metric, ApiMessage } from "@/types";

export const getMetrics = () =>
  api.get<Metric[]>(apiPaths.metrics.list).then((r) => r.data);

export const getMetric = (id: string) =>
  api.get<Metric>(apiPaths.metrics.one(id)).then((r) => r.data);

export const createMetric = (data: Partial<Metric>) =>
  api.post<Metric>(apiPaths.metrics.list, data).then((r) => r.data);

export const updateMetric = (id: string, data: Partial<Metric>) =>
  api.patch<Metric>(apiPaths.metrics.one(id), data).then((r) => r.data);

export const deleteMetric = (id: string) =>
  api.delete<ApiMessage>(apiPaths.metrics.one(id)).then((r) => r.data);
